/*       */

import { gql } from '@apollo/client';
import loadTeamDetailCommonQuery from 'graphql/teams/loadTeamDetailCommonQuery';

export default gql`
    mutation teamRemoveUsersMutation($id: ID!, $users: [ID]!) {
        result: teamRemoveUsers(id: $id, users: $users) {
            ${loadTeamDetailCommonQuery}
        }
    }
`;
